// tracking_scripts/tag_manager/init.ts

import { GTM_logEvent } from './logging';
import { GTM_createCheckoutEvent, GTM_createConfirmationEvent, GTM_createEvent } from './events';
import { GTM_Product } from './product';

declare global {
	interface Window {
		GTM?: any;
	}
}

const GTM_list = window.serverData?.GTM_list;

/**
 * Checks the type of navigation (e.g., back_forward, navigate, reload).
 * Used to determine whether to use sessionStorage retrieval, sending GTM events, etc.
 * @returns {string} The navigation type.
 */
const GTM_navigationType = (): string => {
	const perfEntries = performance.getEntriesByType('navigation');
	const [p] = perfEntries;
	if ('type' in p) {
		return (p as PerformanceNavigationTiming).type;
	}
	return 'navigate';
};

/**
 * Retrieves the page type from the universal_variable.
 * Used to determine how information is stored in the universal_variable.
 * @returns {string} The page type as determined by universal_variable.
 */
const GTM_pageType = (): string => {
	return (window as any).universal_variable?.page?.type || '';
};

/**
 * Initializes the GTM setup based on the current page and navigation types.
 * Should be called on page load to set up GTM events and the product list.
 *
 * @example
 * // Call initialiseGTM on page load
 * initialiseGTM();
 */
export function initialiseGTM(): void {
	const useSessionStorage =
		GTM_navigationType() === 'back_forward' || GTM_pageType() === 'confirmation';

	GTM_list.build(useSessionStorage);

	GTM_logEvent(GTM_list.findAll());

	const pageType = GTM_pageType();

	if (pageType === 'product') {
		const GTM_viewedProductDetails = (window as any).universal_variable?.product;
		if (GTM_viewedProductDetails) {
			const GTM_viewedProduct = new GTM_Product(GTM_viewedProductDetails, 1).getProduct();
			GTM_createEvent(GTM_viewedProduct, 1, 'view_item');
		}
	} else if (pageType === 'confirmation' && GTM_navigationType() === 'navigate') {
		GTM_createConfirmationEvent();
	}
}

window.GTM = window.GTM || {};
window.GTM.createCheckoutEvent = GTM_createCheckoutEvent;
